export default {
      id: "i-car-02-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/sprite.svg#i-car-02",
      toString: function () {
        return this.url;
      }
    }